import { get, find, includes } from 'lodash';

export const isLoadingArticle = (state, articleId) => {
  const articles = get(state, 'news.loadingArticles', []);
  return includes(articles, articleId);
};

export const isLoadingArticles = (state) => {
  const loadingArticles = get(state, 'news.loadingArticles', []);
  return loadingArticles.length > 0;
};

export const hasLoadedArticle = (state, articleId) => {
  const events = get(state, 'news.loadedArticles', []);
  return includes(events, articleId);
};

export const hasAttemptedArticleLoad = (state, articleId) => {
  const articles = get(state, 'news.hasAttemptedLoad', []);
  return includes(articles, articleId);
};

export const getArticle = (state, articleId) => {
  const articles = get(state, 'news.articles', []);
  return find(articles, { id: articleId }) || {};
};

export const getNewsPageLoadingError = (state) => get(state, 'news.newsPageLoadingError');

export const getNewsArticlePageLoadingError = (state, articleId) => {
  const errors = get(state, `news.newsArticlePageLoadingError`);
  const error = get(errors, articleId);

  return error;
};
